'use strict';

class Faq {

    constructor() {

        const faqs = document.querySelectorAll('.faqs');
        const faqOpenClass = 'faq--open';

        // if there is an faq block
        if (faqs) {

            // function to toggle faq
            function toggleFaq(faq, button) {

                const faqContent = faq.querySelector('.faq__content');
                const allLinks = faq.querySelectorAll('a');

                // close faq
                if ( faq.classList.contains(faqOpenClass) ) {

                    faq.classList.remove(faqOpenClass);
                    setMaxHeight(faqContent, 0);
                    button.setAttribute('aria-expanded', 'false');

                    for (let link of allLinks) {

                        link.setAttribute('tabindex', '-1');

                    }
                } 
                
                // open faq
                else {

                    faq.classList.add(faqOpenClass);
                    setMaxHeight(faqContent);
                    button.setAttribute('aria-expanded', 'true');

                    for (let link of allLinks) {

                        link.removeAttribute('tabindex');

                    }
                }

            }

            // function to set max-height
            function setMaxHeight(target, val) {

                if (val || val == 0) {

                    target.style.maxHeight = `${val}px`;

                } else {

                    target.style.maxHeight = `${target.scrollHeight}px`;

                }
                
            }

            // on resize, reset max height on opened faqs
            window.addEventListener('resize', () => {

                for (let faq of faqs) {

                    const faqs = faq.querySelectorAll('.faq');

                    for (let faq of faqs) {

                        if ( faq.classList.contains(faqOpenClass) ) {

                            setMaxHeight(faq.querySelector('.faq__content'));

                        }
                    }

                }

            });

            // on page load initiate faqs
            for (let faq of faqs) {

                const faqs = faq.querySelectorAll('.faq');
             
                for (let faq of faqs) {
                    
                    const toggleButton = faq.querySelector('.faq-toggle-button');                    
                    toggleButton.style.display = '';
                    toggleButton.addEventListener('click', () => { 
                        toggleFaq(faq, toggleButton) 
                    });
                    toggleFaq(faq, toggleButton);
    
                }
            }

        }
    }
}

module.exports = Faq;